import { Navigate, useLocation, Outlet } from "react-router-dom";
import { useAuth } from "../../utility/auth";

export const ProtectedRoute = () => {
  const location = useLocation();
  const auth = useAuth();
  console.log("auth in protected route part ", auth);

  // If no token exists in auth (i.e., user is not authenticated), redirect to the login page
  if (!auth.token) {
    // alert("Navigating to login in auth route protected " + auth.token);
    return <Navigate to="/login" state={{ path: location.pathname }} />;
  }

  // If user is authenticated, render the child routes (using Outlet)
  return <Outlet />;
};
